<!--
  Root is empty when state === 'idle'. When active it renders a fixed-position
  fullscreen overlay. Every element carries data-screenshot-ignore so the
  capture hides them during the render (see ScreenshotService.IGNORE_ATTR).
-->
@if (state === 'selecting') {
  <div class="screenshot-overlay screenshot-overlay--selecting"
    data-screenshot-ignore
    (mousedown)="onSelectMouseDown($event)">

    <!-- Full dim mask, punched out where the selection is -->
    <div class="screenshot-dim" data-screenshot-ignore></div>

    @if (rect && (rect.width > 0 || rect.height > 0)) {
      <div class="screenshot-selection"
        data-screenshot-ignore
        [style.left.px]="rect.x"
        [style.top.px]="rect.y"
        [style.width.px]="rect.width"
        [style.height.px]="rect.height">
      </div>
    }

    <div class="screenshot-hint" data-screenshot-ignore>
      Drag to select area &nbsp;·&nbsp; ESC to cancel
    </div>
  </div>
}

@if (state === 'captured' && rect) {
  <div class="screenshot-overlay screenshot-overlay--captured"
    data-screenshot-ignore
    (click)="onBackdropClickWhileCaptured($event)">

    <!-- Frozen selection outline -->
    <div class="screenshot-selection screenshot-selection--frozen"
      data-screenshot-ignore
      [style.left.px]="rect.x"
      [style.top.px]="rect.y"
      [style.width.px]="rect.width"
      [style.height.px]="rect.height">
    </div>

    <app-screenshot-toolbar
      data-screenshot-ignore
      [rect]="rect"
      (click)="$event.stopPropagation()">
    </app-screenshot-toolbar>
  </div>
}
